import { PropertyMapper } from '../../decorators';

export class SupplierInvoiceType {
    @PropertyMapper()
    public id: number;

    @PropertyMapper()
    public name: string;
}
